export default "__VITE_ASSET__023db34d__"